
import { defineComponent } from "vue";
import Separator from "@/components/Common/Separator.vue";

export default defineComponent({
  name: "BlogContent",
  components: {Separator},
  methods: {
    getBlogTitle(): string {
      return <string> this.$route.meta.title;
    }
  }
});
